<template>
    <v-app>
        <v-main class="body">
            <router-view/>
        </v-main>

        <v-dialog
            max-width="600"
            v-model="alertDialog.visible">
            <v-card>
                <v-card-title>
                    {{ alertDialog.title }}
                </v-card-title>

                <v-card-text>
                    {{ alertDialog.content }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click.stop="$set(alertDialog, 'visible', false)">
                        {{ $t('button.close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'App',

    data () {
        return {
            alertDialog: {
                visible: false,
                title: 'Alert Dialog',
                content: 'Content'
            }
        }
    },

    mounted () {
        this.initializeApplication()
    },

    methods: {
        initializeApplication () {
            Vue.prototype.$app = Vue.$app = this
        },

        alert (title, content) {
            this.$set(this.alertDialog, 'visible', true)
            this.$set(this.alertDialog, 'title', title)
            this.$set(this.alertDialog, 'content', content)
        }
    }
}
</script>

<style lang="scss">
@import './main.scss';
</style>
